import '../pages.css';
import { Link } from 'react-router-dom';

const TitaniumAbutment = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/implants" className="back-link">← Back to Implants/Hybrid</Link>
                    <h1>Titanium Abutment</h1>
                    <p className="product-tagline">Superior strength and reliability</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Titanium abutments from <strong>AbELab</strong> offer superior strength and reliability compared to zirconia
                            alternatives. Each abutment is digitally designed and precision-milled to meet individual patient requirements.
                            The biocompatible nature of titanium supports healthy soft tissue integration around the abutment margins, promoting
                            stable peri-implant tissues and ideal emergence profiles for long-term success.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TitaniumAbutment;
